import {useState} from 'react';
import {initStockStatus, isStockSourceAvailable, SOURCE, updateStockSourceAvailability} from '@Libraries/stock-graphic-library';

export interface StoryblocksAvailability {
  isUnavailable: boolean;
  loadInitial: () => Promise<void>;
  sync: (isAvailable: boolean | undefined) => void;
}

export const useStoryblocksAvailability = (): StoryblocksAvailability => {
  const [isAvailable, setIsAvailable] = useState<boolean | null>(null);

  const loadInitial = async (): Promise<void> => {
    await initStockStatus();
    const initialAvailability = isStockSourceAvailable(SOURCE.STORYBLOCKS);
    setIsAvailable((prev) => prev ?? initialAvailability);
  };

  const sync = (nextIsAvailable: boolean | undefined): void => {
    if (nextIsAvailable === undefined) {
      return;
    }
    updateStockSourceAvailability(SOURCE.STORYBLOCKS, nextIsAvailable);
    setIsAvailable(nextIsAvailable);
  };

  return {
    isUnavailable: isAvailable === false,
    loadInitial,
    sync,
  };
};
